import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { cleanReload } from "./lib/utils.ts";
import { relocation } from "./helpers/site.ts";

// Simple error recovery for cache issues
window.addEventListener("error", (event) => {
  const errorStr = event.error?.toString() || event.message || "";
  if (
    errorStr.includes("Unexpected EOF") ||
    errorStr.includes("Loading chunk")
  ) {
    console.error("Cache issue detected, doing clean reload:", errorStr);
    cleanReload();
  }
});

// courtshuffle.com keeps only the landing page; anything else there moves to
// the app's domain before the app starts.
const destination = relocation();

if (destination) {
  window.location.replace(destination);
} else {
  const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ErrorBoundary>
        <ConvexProvider client={convex}>
          <App />
        </ConvexProvider>
      </ErrorBoundary>
    </StrictMode>,
  );
}
